interface PlacePrediction {
  placeId: string;
  text: {
    text: string;
  };
}

interface AutocompleteResponse {
  suggestions: Array<{
    placePrediction: PlacePrediction;
  }>;
}

export async function getPlacePredictions(
  input: string
): Promise<Array<{ id: string; label: string; value: string }>> {
  if (!input) {
    return [];
  }

  try {
    const response = await fetch(
      'https://places.googleapis.com/v1/places:autocomplete',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Goog-Api-Key': import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
          'X-Goog-FieldMask':
            'suggestions.placePrediction.placeId,suggestions.placePrediction.text.text',
        },
        body: JSON.stringify({
          input: input,
          includedPrimaryTypes: ['(cities)'],
          languageCode: 'en',
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: AutocompleteResponse = await response.json();

    return data.suggestions?.map((suggestion) => ({
      id: suggestion.placePrediction.placeId,
      label: suggestion.placePrediction.text.text,
      value: suggestion.placePrediction.placeId,
    }));
  } catch (error) {
    throw error;
  }
}
